import { ContentfulPageProps } from "../types/vino-data-types";
import { Layout } from "../components/layout";
import { PageHeader } from "../components/page-header";
import PageSection from "../component-factory/page-section";
import * as React from "react";
import SEO from "../components/seo/seo";
import SearchProvider from "../contexts/search/provider";

const ContentfulPage: React.FC<ContentfulPageProps> = ({
  pageContext,
}): JSX.Element => {
  const { page, pagePath } = pageContext;
  const { title, pageSections, noIndex, seoTitle, seoDescription, heroImage } = page;

  const recentArticlesSection = {
    layout: null,
    fullWidth: false,
    spaceAfter: 2,
    spaceBefore: 2,
    internalName: 'recentArticles',
    contentBlocks: [
      {
        __typename: 'VinoData_StaticBlock',
        staticType: 'Recent Articles'
      }
    ]
  }

  return (
    <Layout pathname={pagePath}>
      <SEO
        title={seoTitle || title}
        description={seoDescription}
        type={"page"}
        pathname={pagePath}
        robots={noIndex ? "noindex, nofollow" : "index, follow"}
        image={heroImage?.url}
      />
      <SearchProvider>
        <PageHeader {...page} />
        {pageSections.map((section, index) => {
          return PageSection.create(section, index);
        })}
        { 
          PageSection.create(recentArticlesSection,pageSections.length)
        }
      </SearchProvider>
    </Layout>
  );
};

export default ContentfulPage;
